import { AdminLayout, UserLayout, SuperAdminLayout, FoundLayout, UserlandingLayout, VendorlandingLayout } from "../layouts/index";
import { adminRoutes } from "./Admin/index";
import { superadminRoutes } from "./SuperAdmin/index";
import { userRoutes } from "./User/index";
import { foundRoutes } from "./Found/index";
import { userlandingRoutes } from "./Userlanding/index";
import { vendorlandingRoutes } from "./Vendorlanding";

export const routes = () => {
  return [
    {
      element: <AdminLayout />,
      children: [...adminRoutes()],
    },
    {
      element: <SuperAdminLayout />,
      children: [...superadminRoutes()],
    },
    {
      element: <UserLayout />,
      children: [...userRoutes()],
    },

    {
      element: <UserlandingLayout />,
      children: [...userlandingRoutes()],
    },
    {
      element: <VendorlandingLayout />,
      children: [...vendorlandingRoutes()],
    },
    {
      element: <FoundLayout />,
      children: [...foundRoutes()],
    },
  ];
};

export const routesList = () => {
  let routeArr = [
    ...adminRoutes()[0].children,
    ...adminRoutes()[1].children,
    ...superadminRoutes()[0].children,
    ...superadminRoutes()[1].children,
    ...userRoutes()[0].children,
    ...userRoutes()[1].children,
    ...foundRoutes()[0].children,
    ...userlandingRoutes()[0].children,
    ...vendorlandingRoutes()[0].children,
  ];
  return [...routeArr];
};

export const moduleRoutesList = () => {
  let routeArr = {
    admin: [...adminRoutes()[0].children, ...adminRoutes()[1].children],
    super: [...superadminRoutes()[0].children, ...superadminRoutes()[1].children],
    user: [...userRoutes()[0].children, ...userRoutes()[1].children],
    found: [...foundRoutes()[0].children],
    userlanding: [...userlandingRoutes()[0].children],
  };
  return routeArr;
};

export const getCompletePathList = () => {
  return routesList().reduce((prev, curr) => {
    prev.push(curr);
    if (curr.children) {
      prev.push(...curr.children);
    }
    return prev;
  }, []);
};
